import axios from 'axios'

export async function getPendingContent({
  pagination = { page: 1, pageSize: 25 }
}: {
  pagination: Pagination
}) {
  const response = await axios.get('/unified/api/content', {
    params: {
      filters: {
        state: ['pending']
      },
      pagination
    }
  })

  return {
    data: response.data.content,
    total: response.data.total
  }
}

export async function getSpamContent({
  pagination: { page, pageSize } = { page: 1, pageSize: 25 }
}: {
  pagination: Pagination
}) {
  const searchParams = new URLSearchParams({ page: String(page), pageSize: String(pageSize) })
  const response = await axios.get(
    `/community/api/spamContent?${searchParams}`
  )

  return {
    data: response.data.result,
    total: response.data._metadata.totalCount
  }
}
